import {
  useContext
} from "react";

import {
  EducationDirectionsContext
} from "../context/EducationDirectionsContext";


const useEducationDirections = () => {
  const context = useContext(
    EducationDirectionsContext
  );

  if (!context) {
    throw new Error(
      "useEducationDirections musi być użyty " +
      "wewnątrz EducationDirectionsProvider."
    );
  }

  return context;
};


export default useEducationDirections;